import { render, staticRenderFns } from "./scope59.vue?vue&type=template&id=1fa56fab&scoped=true"
import script from "./scope59.vue?vue&type=script&lang=js"
export * from "./scope59.vue?vue&type=script&lang=js"
import style0 from "./scope59.vue?vue&type=style&index=0&id=1fa56fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa56fab",
  null
  
)

export default component.exports